import { render } from "./MigrationCallout.vue?vue&type=template&id=102561b0&scoped=true"
import script from "./MigrationCallout.vue?vue&type=script&lang=ts"
export * from "./MigrationCallout.vue?vue&type=script&lang=ts"

import "./MigrationCallout.vue?vue&type=style&index=0&id=102561b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-102561b0"

export default script